import { z } from 'zod';

export const createObjectSchema = z.object({
  customerId: z.string().uuid('Bitte einen Kunden auswählen.'),
  name: z.string().min(2, 'Bitte einen Objektnamen eingeben.').max(160),
  address: z.string().max(300).optional().or(z.literal('')),
  accessNotes: z.string().max(2000).optional().or(z.literal('')),
  photoPolicy: z.enum(['ALLOWED', 'RESTRICTED', 'FORBIDDEN']),
});
export type CreateObjectValues = z.infer<typeof createObjectSchema>;

// Beim Bearbeiten fehlt customerId (unveraenderlich).
export const editObjectSchema = createObjectSchema.omit({ customerId: true }).extend({
  active: z.boolean(),
});
export type EditObjectValues = z.infer<typeof editObjectSchema>;
